"use strict";
/**
 * Created by rouven on 13.06.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.wizardReducer = exports.SET_ERROR = exports.STEP_BACK = exports.STEP_FORWARD = exports.DESTROY = exports.INITIALIZE = exports.setError = exports.stepBack = exports.stepForwardPreservingErrors = exports.stepForward = exports.initializeWizard = exports.Step = exports.Wizard = void 0;
var wizardActions_1 = require("./actions/wizardActions");
exports.initializeWizard = wizardActions_1.initializeWizard;
exports.stepForward = wizardActions_1.stepForward;
exports.stepBack = wizardActions_1.stepBack;
exports.setError = wizardActions_1.setError;
exports.stepForwardPreservingErrors = wizardActions_1.stepForwardPreservingErrors;
var actionTypes_1 = require("./actions/actionTypes");
exports.INITIALIZE = actionTypes_1.INITIALIZE;
exports.DESTROY = actionTypes_1.DESTROY;
exports.STEP_FORWARD = actionTypes_1.STEP_FORWARD;
exports.STEP_BACK = actionTypes_1.STEP_BACK;
exports.SET_ERROR = actionTypes_1.SET_ERROR;
var wizardReducer_1 = __importDefault(require("./reducers/wizardReducer"));
exports.wizardReducer = wizardReducer_1["default"];
var Wizard_1 = __importDefault(require("./components/Wizard"));
exports.Wizard = Wizard_1["default"];
var Step_1 = __importDefault(require("./components/Step"));
exports.Step = Step_1["default"];
exports["default"] = Wizard_1["default"];
